// extracted by mini-css-extract-plugin
export default {"Footer":"CarrierFooter_Footer__eDOw-","Button":"CarrierFooter_Button__PRN7u"};